import { Link, useCanGoBack, useRouter } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { StudentListTable } from '~features/students/ui/student-list-table';

import { Button } from '~shared/shadcn/ui/button';

export const StudentListPage = () => {
  const router = useRouter();

  const canGoBack = useCanGoBack();

  return (
    <>
      <div className='mb-4 flex items-center gap-2'>
        {canGoBack ? (
          <Button
            variant={'ghost'}
            className='flex items-center p-0 [&_svg]:size-6'
            onClick={() => {
              router.history.back();
            }}
          >
            <CircleArrowLeft className='size-6' />
          </Button>
        ) : (
          <Button
            variant={'ghost'}
            className='flex items-center p-0 [&_svg]:size-6'
            asChild
          >
            <Link to='/dashboard'>
              <CircleArrowLeft className='size-6' />
            </Link>
          </Button>
        )}
        <h2 className='text-2xl font-bold text-gray-800'>Total Students</h2>
      </div>
      <div className='border-t pt-8'>
        <StudentListTable />
      </div>
    </>
  );
};
